import { encodeHashCobranca } from '@hyperdev-tech/hash-cobranca'

export function getCobrancaUrl(cobrancaId: number): string {
  const isIframe = window !== window.top
  const isStaging = document.location.href.includes('staging')
  const hashCobranca = encodeHashCobranca(cobrancaId)

  if (isIframe)
    return isStaging
      ? `https://sandbox.conta.pilotar.app/cobranca/${hashCobranca}`
      : `https://conta.pilotar.app/cobranca/${hashCobranca}`

  return isStaging
    ? `https://staging--hyperpay.netlify.app/cobranca/${hashCobranca}`
    : `https://rep.hyperpay.com.br/cobranca/${hashCobranca}`
}
